<div class="row birthdate_component">

  <form [formGroup]="dateForm" class="gx-3 mx-0 px-0 row">
    <mat-form-field class="col-4 text_3">
      <mat-label class="text-capitalize subtitle_1 text-black">{{ 'COMMON.DAY' | translate }}</mat-label>
      <mat-select [compareWith]="defaultSelect" [disableOptionCentering]="disableCentering" [formControl]="dayControl"
        [panelClass]="panelClass" class="ps-1 text_3">
        <mat-option *ngFor="let days of createBirthdate('days')" [value]="days">
          {{ days }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="dayControl.hasError('required')">{{ "COMMON.IS_REQUIRED" | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field class="col-4 pb-0 text_3">
      <mat-label class="text-capitalize subtitle_1 text-black">{{ 'COMMON.MONTH' | translate }}</mat-label>
      <mat-select [compareWith]="defaultSelect" [formControl]="monthControl" class="ps-1 text_3"
        [disableOptionCentering]="disableCentering" [panelClass]="panelClass">
        <mat-option *ngFor="let month of createBirthdate('months')" [value]="month +1">
          {{ returnMonthName(month) | date:'MMMM':'':translate.currentLang }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="monthControl.hasError('required')">{{ "COMMON.IS_REQUIRED" | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field class="col-4 pb-0 text_3">
      <mat-label class="text-capitalize subtitle_1 text-black">{{ 'COMMON.YEAR' | translate }}</mat-label>
      <mat-select [compareWith]="defaultSelect" [formControl]="yearControl" class="ps-1 text_3"
        [disableOptionCentering]="disableCentering" [panelClass]="panelClass">
        <mat-option *ngFor="let year of createBirthdate('years')" [value]="year">
          {{ year }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="yearControl.hasError('required')">{{ "COMMON.IS_REQUIRED" | translate }}</mat-error>
    </mat-form-field>
  </form>

</div>
